import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UZURV_REST_CONFIGURATION } from '../../interfaces/uzurv-rest-configuration';

@Injectable()
export class HttpDebugInterceptor implements HttpInterceptor {
  constructor(@Inject(UZURV_REST_CONFIGURATION) protected uzurvRestConfiguration: UzurvRestConfiguration) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.uzurvRestConfiguration.httpDebugMode) {
      if (this.uzurvRestConfiguration.httpDebugMode) {
        console.dir('== HTTP Request == ' + JSON.stringify(request, undefined, 2));
      }
    }

    return next
      .handle(request)
      .pipe(
        map(event => {
          if (this.uzurvRestConfiguration.httpDebugMode) {
            if (event instanceof HttpResponse) {
              console.dir('== HTTP Response == ' + JSON.stringify(event, undefined, 2));
            }
          }
          return event;
        })
      )
      .pipe(
        catchError(response => {
          if (this.uzurvRestConfiguration.httpDebugMode) {
            console.dir('== HTTP Error == ' + JSON.stringify(response, undefined, 2));
          }
          return throwError(response);
        })
      );
  }
}
